/* eslint-disable import/prefer-default-export */
import { createRoutine } from 'redux-saga-routines';

export const fetchCalendarEvents = createRoutine('FETCH_CALENDAR_EVENTS');
export const updateCalendarEventByLinkEntities = createRoutine(
  'UPDATE_CALENDAR_EVENT_BY_LINK_ENTITIES'
);
export const loadMoreCalendarEventsByEntity = createRoutine(
  'LOAD_MORE_CALENDAR_EVENTS_BY_ENTITY'
);
export const clearCalendarEvents = createRoutine('CLEAR_CALENDAR_EVENTS');
